import React from 'react';
import { useTourContext } from './TourProvider';
import type { GlobalTourPhase } from '@components/tours/types';

interface GlobalTourOverlayProps {
  phase: GlobalTourPhase;
  currentSegment: number;
  totalSegments: number;
  segmentName?: string;
}

const getPhaseMessage = (phase: GlobalTourPhase, segmentName?: string): string => {
  switch (phase) {
    case 'navigating':
      return segmentName ? `Navigating to ${segmentName}...` : 'Navigating...';
    case 'waiting-for-mount':
      return 'Loading page...';
    case 'injecting-data':
      return 'Preparing tour...';
    default:
      return '';
  }
};

export const GlobalTourOverlay: React.FC<GlobalTourOverlayProps> = ({
  phase,
  currentSegment,
  totalSegments,
  segmentName,
}) => {
  const shouldShow = phase === 'navigating' || phase === 'waiting-for-mount' || phase === 'injecting-data';

  if (!shouldShow) {
    return null;
  }

  const message = getPhaseMessage(phase, segmentName);

  return (
    <div className="sf-tour-transition-overlay">
      <div className="sf-tour-transition-content">
        <div className="sf-tour-transition-spinner" />
        <div className="sf-tour-transition-message">{message}</div>
        <div className="sf-tour-transition-progress">
          Area {currentSegment + 1} of {totalSegments}
        </div>
      </div>
    </div>
  );
};

export default GlobalTourOverlay;
